import { api } from '@/scripts/api';
export const EmailInboxService = {

    getIntegratedAccounts(id){
        return new Promise((resolve, reject) => {
            const service = `/ms/email-inbox/v1/integrations?clientId=${id}`;
            api
            .get(service)
            .then(resolve)
            .catch(reject);
        });
    },

    getIntegratedAccountsDropdown(id){
        return new Promise((resolve, reject) => {
            const service = `/ms/email-inbox/v1/integrations/dropdown?clientId=${id}`;
            api
            .get(service)
            .then(resolve)
            .catch(reject);
        });
    },

    updateAccount(id, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/email-inbox/v1/integrations/${id}/update`;
            api
            .msPatch(service, payload)
            .then(resolve)
            .catch(reject);
        });
    },

    updateDefaultAccount(id, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/email-inbox/v1/integrations/${id}/default`;
            api
            .msPatch(service, payload)
            .then(resolve)
            .catch(reject);
        });
    },

    removeAccount(id){
        return new Promise((resolve, reject) => {
            const service = `/ms/email-inbox/v1/integrations/${id}/remove`;
            api
            .delete(service)
            .then(resolve)
            .catch(reject);
        });
    },

    getAuth(provider){
        return new Promise((resolve, reject) => {
            const service = `/ms/email-inbox/v1/providers/${provider}/auth`;
            api
            .getFetch(service)
            .then(resolve)
            .catch(reject);
        });
    },

    sendEmail(payload){
        return new Promise((resolve, reject) => {
            const service = '/ms/email-inbox/v1/messages';
            api
            .post(service, payload)
            .then(resolve)
            .catch(reject);
        });
    },

    updateEmail(integrationId, clientId, payload){
        return new Promise((resolve, reject) => {
            const service = `/ms/email-inbox/v1/messages/${integrationId}?clientId=${clientId}`;
            api
            .msPatch(service, payload)
            .then(resolve)
            .catch(reject);
        });
    }
}